module.exports = __webpack_public_path__ + "img/y_p2_guanxian.487ef3c0.svg";